import { queryLngLat } from '@/lib/queryRemoteTiles';
const QUERYZOOM = 15;

async function getBoundaryForPoint(stage, lngLatStr) {
    const lngLat = lngLatStr.map((x) => +x);

    const tilesetId = `dta`; // don't use stage

    const result = await queryLngLat(
        `${window.app.tileHost}/tiles/${tilesetId}/{z}/{x}/{y}.pbf`,
        lngLat,
        QUERYZOOM,
        'dta',
        { quiet: false }
    );
    if (result && result.features) {
        return result.features.map((f) => f.properties);
    } else {
        console.log(`No boundary for dta ${lngLat}`);
    }
}

export { getBoundaryForPoint };
